module.exports = __webpack_public_path__ + "static/media/portfolio1 (58).b106220a.jpeg";